import {
  TagTriggerOption,
  UserTriggerOption,
} from './components/controlled-select-based-editor-trigger-content';
import { TagComponents, UserComponents } from '../../atoms/select';
import { VirtualizedMenuList } from '../../atoms/select/virtualized-menu-list';

export const UserEditorComponents = {
  ...UserComponents,
  TriggerOption: UserTriggerOption,
};
export const CreatedByEditorComponent = {
  ...UserEditorComponents,
  MenuList: VirtualizedMenuList,
};
export const TagEditorComponents = {
  ...TagComponents,
  TriggerOption: TagTriggerOption,
};
